var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.134 6.409a2.119 2.119 0 100-4.238 2.119 2.119 0 000 4.238zm0-3.591a1.482 1.482 0 110 2.963 1.482 1.482 0 010-2.963zM7.924 7.204h-1.58A3.196 3.196 0 003.146 10.4a.321.321 0 00.322.32h7.33a.321.321 0 00.32-.32 3.196 3.196 0 00-3.195-3.196zM3.809 10.08a2.558 2.558 0 012.534-2.233h1.58a2.558 2.558 0 012.534 2.233H3.81z"
  })));
}
export default SvgProfile;